import React, { Component } from 'react'
import { List } from 'immutable'
import { IOnBoardingLandingProps } from './interface';

import ProTrackItem from './ProTrackItem'

import './styles.scss'
export const bc = 'on-boarding-landing'

class OnBoardingLanding extends Component<IOnBoardingLandingProps> {

  static defaultProps = {
    fullNameOrEmail: 'Someone',
    text: 'The ProHabits program is reserved for culture leaders inspiring change inside transforming organizations.',
    description:
      'Daily reminders to bring the best version of yourself to life. If you commit in the morning, another message arrives later to ask if you did it.',
    quoteImage: 'https://assets.prohabits.com/prohabits/welcome.jpg',
    proTracks: List(),
  }

  render() {
    const {
      t,
      fullNameOrEmail,
      text,
      proTracks,
      quoteImage,
      srcOrganizationLogo,
      setQueriesAndGoToDashboard,
      description,
      isSMSAvailable,
      isTextIncludeHtmlTags,
      isDescriptionIncludeHtmlTags,
    } = this.props
    const isProTrackLevelsExists = proTracks.size > 0
    return (
      <div className={bc}>
        <img className={`${bc}__organization-logo`} src={srcOrganizationLogo} alt={t(`Organization's Logo`)} />
        <div className={`${bc}__body`}>
          <img className={`${bc}__content-image`} src={quoteImage} alt={t('Welcome image')} />
          <div className={`${bc}__content`}>
            <div className={`${bc}__greeting`}>
              <span className={`${bc}__greeting-title`}>{t('Hi', { fullNameOrEmail })}</span>
              {isTextIncludeHtmlTags ? (
                <span className={`${bc}__greeting-subtitle`} dangerouslySetInnerHTML={{ __html: text }} />
              ) : (
                  <span className={`${bc}__greeting-subtitle`}>{t(text)}</span>
                )}
            </div>
            <div className={`${bc}__micro-actions`}>
              {isDescriptionIncludeHtmlTags ? (
                <span
                  className={`${bc}__micro-actions-description`}
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              ) : (
                  <span className={`${bc}__micro-actions-description`}>{t(description)}</span>
                )}
              <img
                className={`${bc}__micro-actions-image`}
                src={`https://assets.prohabits.com/prohabits/welcome-microactions${
                  !isSMSAvailable ? '-email' : ''
                  }.jpg`}
                alt={isSMSAvailable ? t('Simple MicroActions via email or text') : t('Simple MicroActions via email')}
              />
            </div>
            <div className={`${bc}__do-you-commit`}>
              {isProTrackLevelsExists ? t('Click Start below to accept the invitation and begin ProHabits') :
                  t('Please contact Happy@ProHabits.com to request access')}
            </div>
            {isProTrackLevelsExists && proTracks.map((proTrack, i) => (
              <ProTrackItem key={i} setQueriesAndGoToDashboard={setQueriesAndGoToDashboard} {...proTrack.toJS()} />
            ))}
            <div className={`${bc}__sign`}>{t('“We are what we repeatedly do”')}</div>
          </div>
        </div>
      </div>
    )
  }
}


export default OnBoardingLanding
